import React, { useContext } from "react";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import since2024 from "../../asset/since2024.png";
import dealImage from "../../asset/dealimage.png";
import experienceImage from "../../asset/Experience.png";
import { CanvasContext } from "../../contexts/CanvasContext";
import "./BestITSolutions.css";

const BestITSolutions = () => {
  const controls = useAnimation();
  const { isDarkTheme } = useContext(CanvasContext);

  const [ref, inView] = useInView({
    triggerOnce: false,
    threshold: 0.1,
  });

  React.useEffect(() => {
    if (inView) {
      controls.start("visible");
    } else {
      controls.start("hidden");
    }
  }, [controls, inView]);

  const contentVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };

  const imageVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };

  const reverseImageVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };

  return (
    <div
      className={`best-it-solutions ${isDarkTheme ? "dark-theme" : ""}`}
      ref={ref}
    >
      <motion.section
        className={`hero ${isDarkTheme ? "dark-theme" : ""}`}
        animate={controls}
        initial="hidden"
      >
        <motion.div className="hero-content" variants={contentVariants}>
          <h1>The Leading Web Development Platform Since 2024</h1>
          <p>
            At NexGen Sites, we revolutionize the way websites are created.
            Since our inception, we've been at the forefront of simplifying web
            development, offering a platform where anyone can build stunning
            websites without writing a single line of code. Our platform is
            designed to be intuitive and powerful, allowing users to bring their
            digital visions to life with ease.
          </p>
          <p>
            Experience the future of website creation with our state-of-the-art
            tools and user-friendly interface. From drag-and-drop functionality
            to advanced customization options, NexGen Sites ensures that every
            project is unique and professionally crafted. Join the community of
            innovators who are transforming the web with us.
          </p>
          <button className="join-now">Join Now</button>
        </motion.div>
        <motion.div className="hero-image" variants={imageVariants}>
          <img src={since2024} alt="Person pointing at a board" />
        </motion.div>
      </motion.section>

      <motion.section className="services" animate={controls} initial="hidden">
        <motion.div className="services-image" variants={reverseImageVariants}>
          <img src={dealImage} alt="Person using a laptop" />
        </motion.div>
        <motion.div className="services-content" variants={contentVariants}>
          <h2>We Provide Comprehensive Solutions for Web Development</h2>
          <p>
            At NexGen Sites, we address every aspect of web creation with
            professionalism and expertise. As the digital landscape evolves, we
            ensure that our platform meets the highest standards of innovation
            and usability.
          </p>
          <div className="service-features">
            <div className="feature">
              <i className="fas fa-globe-americas"></i>
              <span>Global Reach</span>
            </div>
            <div className="feature">
              <i className="fas fa-headset"></i>
              <span>24/7 Support</span>
            </div>
            <div className="feature">
              <i className="fas fa-laptop"></i>
              <span>User-Friendly Interface</span>
            </div>
            <div className="feature">
              <i className="fas fa-rocket"></i>
              <span>Cutting-Edge Technology</span>
            </div>
          </div>
        </motion.div>
      </motion.section>

      <motion.section
        className="experience"
        animate={controls}
        initial="hidden"
      >
        <motion.div className="experience-content" variants={contentVariants}>
          <h2>Create Websites Without Coding – NexGen Sites</h2>
          <p>
            With our innovative platform, you can build fully functional
            websites effortlessly. Leverage our drag-and-drop interface,
            extensive component library, and customization options to craft
            professional-grade sites with ease.
          </p>
          <div className="experience-bars">
            <div className="bar">
              <span>Website Building</span>
              <div className="progress-container">
                <div className="progress" style={{ width: "80%" }}></div>
              </div>
              <span>80%</span>
            </div>
            <div className="bar">
              <span>Component Customization</span>
              <div className="progress-container">
                <div className="progress" style={{ width: "90%" }}></div>
              </div>
              <span>90%</span>
            </div>
            <div className="bar">
              <span>Responsive Design</span>
              <div className="progress-container">
                <div className="progress" style={{ width: "75%" }}></div>
              </div>
              <span>75%</span>
            </div>
          </div>
        </motion.div>
        <motion.div className="experience-image" variants={imageVariants}>
          <img src={experienceImage} alt="Person with icons" />
        </motion.div>
      </motion.section>
    </div>
  );
};

export default BestITSolutions;
